/* ZilZal - header game picker list, collection search, and label tagging.

   CSS cannot select an element by its text, so anything that has to be matched
   by label is tagged here and hidden by CSS. */
(function () {
  'use strict';

  var FILTER_WORDS = ['\u0641\u0644\u062a\u0631', '\u0645\u0631\u0634\u062d\u0627\u062a'];
  var GAME_LABEL = '\u0627\u062e\u062a\u064a\u0627\u0631 \u0627\u0644\u0644\u0639\u0628\u0629';

  function markCurrent(picker) {
    var path = decodeURIComponent(window.location.pathname);
    var items = picker.querySelectorAll('[data-zzgp-url]');
    for (var i = 0; i < items.length; i++) {
      var url = decodeURIComponent(items[i].getAttribute('data-zzgp-url') || '');
      var parts = url.split('/collections/');
      if (parts.length < 2) continue;
      var handle = parts[1].split('?')[0].split('#')[0];
      if (!handle || path.indexOf(handle) === -1) continue;
      items[i].classList.add('is-current');
      var lbl = picker.querySelector('[data-zzgp-label]');
      var thumb = picker.querySelector('[data-zzgp-thumb]');
      var nameEl = items[i].querySelector('span:last-child');
      var img = items[i].querySelector('img');
      if (lbl && nameEl) lbl.textContent = nameEl.textContent.trim();
      if (thumb && img) {
        thumb.textContent = '';
        var t = document.createElement('img');
        t.src = img.getAttribute('src');
        t.alt = '';
        thumb.appendChild(t);
      }
      break;
    }
  }

  function buildPickerList() {
    var picker = document.getElementById('zzgamepick');
    if (!picker) return;
    var list = picker.querySelector('[data-zzgp-list]') || picker.querySelector('.zzgp__panel');
    if (!list || list.querySelector('[data-zzgp-url]')) return;
    var source = document.querySelectorAll('#zzmenu .zzm__game');
    if (!source.length) return;
    var all = list.querySelector('.zzgp__all');
    var frag = document.createDocumentFragment();
    Array.prototype.forEach.call(source, function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href === '#') return;
      var nameEl = a.querySelector('.zzm__game-name');
      var name = nameEl ? nameEl.textContent.trim() : '';
      var img = a.querySelector('img.zzm__ic');
      var item = document.createElement('a');
      item.className = 'zzgp__item';
      item.href = href;
      item.setAttribute('data-zzgp-url', href);
      item.setAttribute('data-zzgp-name', name.toLowerCase());
      if (img) {
        var im = document.createElement('img');
        im.src = img.getAttribute('src');
        im.alt = '';
        im.loading = 'lazy';
        item.appendChild(im);
      } else {
        var ph = document.createElement('span');
        ph.className = 'zzgp__ph';
        ph.textContent = name.charAt(0) || '?';
        item.appendChild(ph);
      }
      var lab = document.createElement('span');
      lab.textContent = name;
      item.appendChild(lab);
      frag.appendChild(item);
    });
    if (all) list.insertBefore(frag, all);
    else list.appendChild(frag);
    markCurrent(picker);
  }

  function makeSearch(bar) {
    if (!bar || bar.querySelector('.zzcs')) return;
    var wrap = document.createElement('div');
    wrap.className = 'zzcs';

    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    var c = document.createElementNS(ns, 'circle');
    c.setAttribute('cx', '11'); c.setAttribute('cy', '11'); c.setAttribute('r', '7');
    c.setAttribute('stroke', 'currentColor'); c.setAttribute('stroke-width', '2');
    var p = document.createElementNS(ns, 'path');
    p.setAttribute('d', 'm20 20-3.2-3.2');
    p.setAttribute('stroke', 'currentColor'); p.setAttribute('stroke-width', '2');
    p.setAttribute('stroke-linecap', 'round');
    svg.appendChild(c); svg.appendChild(p);
    wrap.appendChild(svg);

    var input = document.createElement('input');
    input.type = 'search';
    input.autocomplete = 'off';
    input.placeholder = '\u0627\u0628\u062d\u062b \u0639\u0646 \u0639\u0646\u0627\u0635\u0631';
    wrap.appendChild(input);

    bar.insertBefore(wrap, bar.firstChild);

    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      document.querySelectorAll('[data-bxc-card]').forEach(function (card) {
        var t = card.querySelector('.bxc-card__title');
        var name = t ? t.textContent.trim().toLowerCase() : '';
        card.style.display = !q || name.indexOf(q) !== -1 ? '' : 'none';
      });
    });
  }

  function placeCollectionSearch() {
    makeSearch(document.querySelector('.bxc-topbar'));
    makeSearch(document.querySelector('.bxc-mobilebar'));
  }

  function tagFilterButton() {
    var bars = document.querySelectorAll('.bxc-topbar, .bxc-mobilebar');
    Array.prototype.forEach.call(bars, function (bar) {
      Array.prototype.forEach.call(bar.querySelectorAll('button, a, [role=button]'), function (el) {
        if (el.hasAttribute('data-zz-filterbtn')) return;
        var txt = (el.textContent || '').trim();
        for (var i = 0; i < FILTER_WORDS.length; i++) {
          if (txt.indexOf(FILTER_WORDS[i]) !== -1) {
            el.setAttribute('data-zz-filterbtn', '1');
            return;
          }
        }
      });
    });
  }

  /* The game chooser heading inside the filter rail. The :has() rule did not
     match it, so it is found by its text and its whole group is tagged. */
  function tagGameLabel() {
    var rail = document.querySelector('.bxc-side');
    if (!rail) return;
    var nodes = rail.querySelectorAll('h1, h2, h3, h4, h5, h6, div, span, p, label');
    Array.prototype.forEach.call(nodes, function (el) {
      if (el.hasAttribute('data-zz-gamelabel')) return;
      var txt = (el.textContent || '').trim();
      if (txt !== GAME_LABEL) return;
      /* Tag the label and the group wrapping it, so no empty block is left. */
      el.setAttribute('data-zz-gamelabel', '1');
      var group = el.closest('.bxc-fgroup');
      if (group) group.setAttribute('data-zz-gamelabel', '1');
      else {
        var sib = el.nextElementSibling;
        if (sib && !sib.querySelector('input, select')) sib.setAttribute('data-zz-gamelabel', '1');
      }
    });
  }

  function boot() {
    buildPickerList();
    placeCollectionSearch();
    tagFilterButton();
    tagGameLabel();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
  setTimeout(boot, 600);
  setTimeout(boot, 1600);
})();
